import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useDemo } from '@/contexts/DemoContext';
import { useSupportMode } from '@/contexts/SupportModeContext';
import { Loader2 } from 'lucide-react';

import {
  PLATFORM_ADMIN_HOME,
  isPlatformAdminPath,
} from '@/features/post-login-redirect';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { session, profile, loading } = useAuth();
  const { isDemo, demoRole } = useDemo();
  const { active: isSupportMode } = useSupportMode();
  const location = useLocation();

  // Demo-Modus: Therapeuten-Ansicht direkt durchlassen
  if (isDemo && demoRole === 'therapeut') {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // Platform admins are scoped to `/admin/*`. A deep link to a workflow
  // page would still render the per-page <RoleGuard>'s "no access" panel
  // and confuse the user — bounce them to their actual home instead.
  // Im aktiven Support-Modus sieht der Admin die Kunden-Org und darf
  // dort dieselben Pfade aufrufen wie ein Org-Admin.
  if (
    profile?.role === 'admin' &&
    !isSupportMode &&
    !isPlatformAdminPath(location.pathname)
  ) {
    return <Navigate to={PLATFORM_ADMIN_HOME} replace />;
  }

  return <>{children}</>;
};
